class ajaxCart extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#ajaxcart-overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }
  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#ajax-cart-icon');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink)
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }
  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {this.classList.add('animate', 'active')});
    this.addEventListener('transitionend', () => {
      const containerToTrapFocusOn = this.classList.contains('is-empty') ? this.querySelector('.cart-inner-empty') : document.getElementById('ajaxcart');
      const focusElement = this.querySelector('.drawer-inner');
      triggerClick(containerToTrapFocusOn, focusElement);
    }, { once: true });
    document.body.classList.add('overflow-hidden');
  }
  close() {
    this.classList.remove('active');
    triggerClickClose(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }
  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');
    if(cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }
    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });
    cartDrawerNote.parentElement.addEventListener('keyup', escClick);
  }
  renderContents(parsedState) {
    this.querySelector('.drawer-inner').classList.contains('is-empty') && this.querySelector('.drawer-inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    // Update cart drawer
    const cartSection = parsedState.sections['ajax-cart'];
    if (cartSection) {
      const ajaxcart = document.querySelector('#ajaxcart');
      if (ajaxcart) ajaxcart.innerHTML = this.callSectionInnerHTML(cartSection, '#ajaxcart');
    }
    // Update cart icon counter
    const iconSection = parsedState.sections['ajax-cart-icon'];
    if (iconSection) {
      const parsed = new DOMParser().parseFromString(iconSection, 'text/html');
      const newCounter = parsed.querySelector('.bigcounter');
      if (newCounter) {
        document.querySelectorAll('.bigcounter').forEach(el => {
          el.innerHTML = newCounter.innerHTML;
        });
      }
    }
    setTimeout(() => {
      this.querySelector('#ajaxcart-overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }
  callSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }
  fetchSecToInclude() {
    return [
      {
        id: 'ajax-cart',
        selector: '#ajaxcart'
      },
      {
        id: 'ajax-cart-icon'
      }
    ];
  }
  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector);
  }
  setActiveElement(element) {
    this.activeElement = element;
  }
}
customElements.define('ajax-cart', ajaxCart);
class ajaxCartPro extends CartProduct {
  fetchSecToInclude() {
    return [
      {
        id: 'ajaxcart',
        section: 'ajax-cart',
        selector: '.drawer-inner'
      }
    ];
  }
  refreshQty(line, quantity, name) {
    this.loadingShow(line);
    const body = JSON.stringify({
      line,
      quantity,
      sections: ['ajax-cart', 'ajax-cart-icon'],
      sections_url: window.location.pathname
    });
    fetch(`${routes.edite_cart_url}`, { ...stFetchConfig(), ...{ body } })
      .then(r => r.json())
      .then(parsedState => {
        if (parsedState.errors) {
          const qtyEl = document.getElementById(`Drawer-quantity-${line}`);
          if (qtyEl) qtyEl.value = qtyEl.getAttribute('value');
          return;
        }
        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector('ajax-cart');
        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);
        // Update drawer
        if (parsedState.sections['ajax-cart']) {
          const ajaxcart = document.getElementById('ajaxcart');
          if (ajaxcart) {
            const parsed = new DOMParser().parseFromString(parsedState.sections['ajax-cart'], 'text/html');
            const drawerInner = parsed.querySelector('.drawer-inner');
            if (drawerInner) ajaxcart.querySelector('.drawer-inner').innerHTML = drawerInner.innerHTML;
          }
        }
        // Update counter
        if (parsedState.sections['ajax-cart-icon']) {
          const parsed = new DOMParser().parseFromString(parsedState.sections['ajax-cart-icon'], 'text/html');
          const newCounter = parsed.querySelector('.bigcounter');
          if (newCounter) {
            document.querySelectorAll('.bigcounter').forEach(el => {
              el.innerHTML = newCounter.innerHTML;
            });
          }
        }
        live(SP_OBJECT.ajxcartRefresh, {source: 'ajax-items'});
      })
      .catch(e => console.error('Cart update error:', e))
      .finally(() => this.loadingOff(line));
  }
}

customElements.define('cart-pro', ajaxCartPro);
